// Get/Get id
export const EMPLOYEES_GET = "employeesGet";
export const EMPLOYEE_GET = "employeeGet";
// Post
export const EMPLOYEE_CREATE = "employeeCreate";
